import React, { FC } from 'react';
import * as S from './styles';

interface RadioProps extends React.HTMLProps<HTMLInputElement> {
  isChecked: boolean;
  label?: string;
  id?: string;
}

const Radio: FC<RadioProps> = ({ id, isChecked, label, onChange }) => {
  return (
    <S.Container>
      <S.RadioInput
        type="radio"
        id={`check-${id}`}
        name={label}
        value={label}
        checked={isChecked}
        onChange={onChange}
        readOnly={!onChange}
      />
      {!!label && <S.RadioLabel htmlFor={label}>{label}</S.RadioLabel>}
    </S.Container>
  );
};

export default Radio;
